import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

export const COMPANY = {
  name: "WASHINGTON ROTATING ELECTRICS",
  short: "WRE",
  tagline: "Starters & Alternators.",
  phone: "+44 7840 814864",
  whatsapp: "447840814864",
  email: "info@wrene.co.uk",
  address: "Washington, North East England",
  hours: "Mon–Fri 08:00–17:00",
};
